<template>
  <sl-side-panel v-model="modalVisible" :mask-closable="false" :title="itemTitle">
    <Form class="sm" ref="form" :model="form" :rules="rules" :label-width="100">
      <FormItem label="所属大纲" prop="categoryId">
        <sl-select v-model="form.categoryId" type="select" :dict="examCategories"></sl-select>
      </FormItem>
      <FormItem label="适用证照" prop="licenseIds">
        <license-select v-model="form.licenseIds" />
      </FormItem>
      <FormItem label="题目类型" prop="examType">
        <sl-select v-model="form.examType" type="radio" dict="$questionType"></sl-select>
      </FormItem>
      <FormItem label="题目" prop="title">
        <Input v-model="form.title" :maxlength="64"></Input>
      </FormItem>
      <FormItem label="答案" prop="optionList">
        <answer ref="answer" :type="this.form.examType" :data="optionList" :answer="form.defaultAnswer" @on-change="handleChange"></answer>
      </FormItem>
      <!--       <FormItem label="备注" prop="remark">
        <Input type="textarea" :autosize="{minRows: 5,maxRows: 8}" v-model="form.remark"></Input>
      </FormItem> -->
    </Form>
    <div slot="footer">
      <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
    </div>
  </sl-side-panel>
</template>
<script>
import answer from './answer'
import licenseSelect from '../../license/partial/license-select'
export default {
  components: { answer , licenseSelect },
  data() {
    return {
      rules: {
        title: [{ required: true, message: '题目不能为空', trigger: 'blur,change' }],
        content: [{ required: true, message: '题目不能为空', trigger: 'blur,change' }],
        examType: [{ type: 'number', required: true, message: '请选择题目类型', trigger: 'blur,change' }],
        licenseIds:[{ type: 'array', required: true, message: '请选择适用证照', trigger: 'blur,change' }]
      },
      def: {},
      form: {
        id: null,
        examType: null,
        title: null,
        content: null,
        categoryId:null,
        remark: null,
        options: null,
        licenseIds:null,
        defaultAnswer: null
      },
      id: null,
      modalVisible: false,
      loading: false,
      isCreate: true,
      optionList: [],
    }
  },

  created() {
    this.def = { ...this.form }
  },

  computed: {
    itemTitle() {
      return this.id ? '编辑题目' : '添加题目'
    },
    categories(){
      return this.$request.examCategories().then(resp => {
        return Promise.resolve(resp.data.map( i => ({ value:i.id , label:i.title })))
      })
    },
    examCategories(){
      return this.$request.examCategories().then(resp => {
        return Promise.resolve(resp.data.map( i => ({ value:i.id , label:i.title })))
      })
    }
  },
  methods: {
    query() {
      // this.$request.ciEnterprise(this.id).then(resp => {
      this.$request.examQuestion(this.id).then(resp => {
        try{
          this.optionList = resp.data.optionList || []
        }catch(e){
          this.optionList = []
        }

        resp.data.licenseIds = (resp.data.licenses || []).map(i => i.id)
        
        this.$utils.fill(this.form, resp.data)
      })
    },

    init(id) {
      this.id = id
      this.reset()
      this.modalVisible = true
      if (this.id) {
        this.query()
      }
    },

    reset() {
      // this.$refs['answer'].reset()
      this.$refs['form'].resetFields()

      this.$utils.fill(this.form, this.def)
      this.optionList = []
      this.defaultAnswer = null
    },


    save() {
      //
      let params = { ...this.form }

      console.log(params)
      if (params.defaultAnswer && params.defaultAnswer.length > 0) {
        this.loading = true

        let exec = this.id ? this.$request.examQuestionUpdate : this.$request.examQuestionCreate
        exec(params).then(resp => {
          if (resp.code) {
            this.$Message.error({ content: resp.msg })
          } else {
            this.$Message.success('保存成功')
            this.$emit('update')
            this.modalVisible = false
          }
          this.loading = false
        })
      } else {
        this.$Message.error({ content: '请选择正确答案' })
      }


    },

    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          this.$Message.error('参数错误');
        }
      })
    },
    handleClose() {
      this.$emit('update')
    },
    handleChange(data) {
      if ('defaultAnswer' in data) {
        this.form.optionList = data.options
        this.form.defaultAnswer = data.defaultAnswer
      } else {

      }
    }
  }
}

</script>
